var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 24.5L17.9999 18.5M17.9999 18.5L11.9999 24.5M17.9999 18.5V32M30.5849 28.085C32.048 27.2874 33.2037 26.0253 33.8698 24.4979C34.5358 22.9706 34.6743 21.2649 34.2633 19.65C33.8522 18.0352 32.9152 16.6033 31.5999 15.5802C30.2847 14.5571 28.6662 14.0011 26.9999 14H25.1099C24.6559 12.2439 23.8097 10.6135 22.6349 9.2315C21.46 7.84948 19.9872 6.75178 18.3271 6.02092C16.667 5.29005 14.8628 4.94504 13.0501 5.01183C11.2375 5.07862 9.46354 5.55546 7.86171 6.4065C6.25987 7.25755 4.87181 8.46066 3.80187 9.92538C2.73194 11.3901 2.00798 13.0783 1.68441 14.8631C1.36084 16.6479 1.4461 18.4828 1.93376 20.2299C2.42142 21.977 3.2988 23.5908 4.49994 24.95",
    stroke: "#253D87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconFileUpload);
export default __webpack_public_path__ + "static/media/common_icon_file_upload.008b381d55bddf4f666d489cfd7d7d4e.svg";
export { ForwardRef as ReactComponent };